import type { WorkspaceDefinition } from '@/core/ui/workspace'

// docs/upgrade/06 §4 nhóm Kế toán (đợt M1): các màn cùng đối tượng gom thành tab; route cũ redirect sang `?view=`.
export const vouchersWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'advance', labelKey: 'nav.advanceRequests', icon: 'pi pi-money-bill', permission: 'PaymentRequests.Read',
      component: () => import('@/modules/payments/PaymentRequestsView.vue'), props: { kind: 'Advance' } },
    { key: 'payment', labelKey: 'nav.paymentRequests', icon: 'pi pi-credit-card', permission: 'PaymentRequests.Read',
      component: () => import('@/modules/payments/PaymentRequestsView.vue'), props: { kind: 'Payment' } },
    { key: 'settlement', labelKey: 'nav.advanceSettlements', icon: 'pi pi-replay', permission: 'PaymentRequests.Read',
      component: () => import('@/modules/payments/PaymentRequestsView.vue'), props: { kind: 'AdvanceSettlement' } },
  ],
}

export const invoicesWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'sales', labelKey: 'nav.projectInvoices', icon: 'pi pi-receipt', permission: 'ProjectInvoices.Read',
      component: () => import('@/modules/procurement/SalesInvoicesView.vue') },
    { key: 'supplier', labelKey: 'nav.supplierInvoices', icon: 'pi pi-shopping-cart', permission: 'SupplierInvoices.Read',
      component: () => import('@/modules/finance/SupplierInvoicesView.vue') },
  ],
}

export const cashBankWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'cash', labelKey: 'nav.cashBook', icon: 'pi pi-book', permission: 'CashBook.Read',
      component: () => import('@/modules/payments/CashBookView.vue') },
    { key: 'bank', labelKey: 'nav.bankStatements', icon: 'pi pi-building-columns', permission: 'BankStatements.Read',
      component: () => import('@/modules/finance/BankStatementView.vue') },
  ],
}

export const financeWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'statement', labelKey: 'nav.financeStatement', icon: 'pi pi-chart-bar', permission: 'Finance.Read',
      component: () => import('@/modules/finance/FinanceStatementView.vue') },
    { key: 'period-close', labelKey: 'nav.financePeriodClose', icon: 'pi pi-lock', permission: 'Finance.Read',
      component: () => import('@/modules/finance/FinancePeriodCloseView.vue') },
    { key: 'amortizations', labelKey: 'nav.amortizations', icon: 'pi pi-calendar-clock', permission: 'Amortizations.Read',
      component: () => import('@/modules/finance/AmortizationsView.vue') },
    { key: 'catalog', labelKey: 'nav.financeReportCatalog', icon: 'pi pi-book', permission: 'Reports.Read',
      component: () => import('@/modules/reports/FinanceReportCatalogView.vue') },
  ],
}

export const accountingCatalogsWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'expense', labelKey: 'nav.expenseCategories', icon: 'pi pi-tags', permission: 'ExpenseCategories.Read',
      component: () => import('@/modules/payments/ExpenseCategoriesView.vue') },
    { key: 'rates', labelKey: 'exchangeRates.title', icon: 'pi pi-dollar', permission: 'ExchangeRates.Read',
      component: () => import('@/modules/exchangeRates/ExchangeRatesView.vue') },
  ],
}
